import { Component } from "react";
import TopNav from "../components/top_nav";
import Footer from "../components/footer";
import { ArrowRight } from 'react-bootstrap-icons';

export default class HomeScreen extends Component {
  componentDidMount() {
    this.scrollToHash();
  }

  componentDidUpdate() {
    this.scrollToHash();
  }

  scrollToHash() {
    const hash = window.location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        // Use smooth scrolling
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }


  render() {
    return (
      <div>
        <TopNav />

        {/* Hero Section */}
        <div className="position-relative px-3 d-flex align-items-center hero-section" style={{ height: "120vh" }}>
          {/* Main Background: Video */}
          {/* <img
            src="/Video.gif"
            alt="Video"
            className="img-fluid w-100 h-100 position-absolute top-0 start-0"
            style={{ objectFit: "cover", zIndex: 1 }}
          /> */}
          <video
            src="/Video.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="img-fluid w-100 h-100 position-absolute top-0 start-0"
            style={{ objectFit: "cover", zIndex: 1 }}
          ></video>

          {/* Frame Overlay on top of Video */}
          <img
            src="/Frame.webp"
            alt="Frame"
            className="img-fluid w-100 h-100 position-absolute top-0 start-0"
            style={{ objectFit: "cover", zIndex: 2, opacity: 0.8 }}
          />

          {/* Text on top of both */}
          <div
            className="position-absolute top-50 start-50 translate-middle text-white w-100 px-3 px-md-5"
            style={{ zIndex: 3 }}
          >
            <div className="col-12 col-md-7">
              <p className="hero-title fw-normal">Driving Innovation for Railway Excellence</p>
            </div>
            <div className="col-12 col-md-5">
              <p className="mt-3 hero-description" style={{ fontSize: "18px" }}>
                Empowering the future of railways with cutting-edge solutions for automation, safety, and efficiency.
              </p>
            </div>
          </div>
        </div>


        <div className="container mt-5 text-center">
          <div className="d-flex justify-content-center">
            <h3 className="col-md-6 fs-26">Partnered With</h3>
          </div>

          <div className="row justify-content-center">
            <div className="p-4 py-md-4 px-md-5">
              <div className="d-flex flex-wrap justify-content-between align-items-center gap-4">
                {["client1", "client2", "client3", "client5"].map((client, index) => (
                  <div
                    key={index}
                    className="d-flex justify-content-center align-items-center"
                    style={{ width: "150px", height: "80px" }}
                  >
                    <img
                      src={`/${client}.webp`}
                      alt={client}
                      className="img-fluid"
                      style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", filter: "grayscale(100%)" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>




        <div className="container my-5">
          <div className="  p-4 p-md-5 rounded-4">
            <div className="row align-items-center">
              {/* Text Section */}
              <div className="col-md-6">
                <span className="badge  fw-normal rounded-pill border-primary-blue text-primary-blue px-3 py-2 mb-3 fs-16">
                  <span className="me-2 text-success fs-16">●</span>What we Do
                </span>
                <p className="fs-36 fw-bold mb-3">Tailored Solutions</p>
                <p className="text-primary-blue">
                  We partner with governments, rail operators, infrastructure owners, and engineering teams to deliver
                  high-performance systems that meet the evolving demands of modern transportation. Whether it's new
                  installations or upgrading legacy systems
                </p>
                <p className="fs-20 text-primary-blue">
                  — We build solutions that scale with your vision.
                </p>
                <button
                  onClick={() => window.location.href = "solutions"}
                  className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-5 bg-primary-blue"
                >
                  <span className="mx-3 fs-14">Explore Our Solutions</span>
                  <div
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    style={{
                      width: '35px',
                      height: '35px',
                      backgroundColor: '#ffffff',
                    }}
                  >
                    <ArrowRight color="#193E6C" />
                  </div>
                </button>
              </div>

              <div className="col-md-6 text-center mt-4 mt-md-0">
                <img
                  src="/train.webp"
                  alt="Train"
                  className="img-fluid rounded-4 shadow-sm w-100 h-100"
                  style={{ maxHeight: '350px', objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>
        </div>



        <div className="container my-5">
          <div className="row align-items-center justify-content-between p-4 p-md-5">
            <div className="col-md-5 mb-5 mb-lg-0">
              <span className="badge fw-normal rounded-pill border-primary-blue text-primary-blue px-3 py-2 mb-3 fs-16">
                <span className="me-2 text-success fs-16">●</span>How we do
              </span>
              <h2 className="fw-bold mb-3 fs-36">Engineering Delivery Framework</h2>
              <p className=" text-primary-blue w-90 ">
                BHEPL’s streamlined approach delivers high-performance rail and infrastructure solutions—scalable,
                reliable, and built for the future. From early alignment to long-term sustainment, we ensure seamless
                integration and stakeholder alignment at every stage.
              </p>
              <p className="fw-bold text-primary-blue fs-20 w-90">
                —We don’t just build systems—we engineer progress.
              </p>
              <button
                onClick={() => window.location.href = "innovation"}
                className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-5 bg-primary-blue"
              >
                <span className="mx-3 fs-14">Learn more</span>
                <div
                  className="d-flex justify-content-center align-items-center rounded-circle"
                  style={{
                    width: '35px',
                    height: '35px',
                    backgroundColor: '#ffffff',
                  }}
                >
                  <ArrowRight color="#193E6C" />
                </div>
              </button>
            </div>

            <div className="col-md-7 text-center">
              <img
                src="/flow.webp"
                alt="Flow"
                className="img-fluid w-100 h-100"
                style={{ objectFit: 'cover', maxHeight: '560px' }}
              />
            </div>
          </div>
        </div>


        <div className="container my-5">
          <div className="row align-items-center p-4 p-md-5 justify-content-between">
            <div className="col-md-6 mb-4 mb-md-0 pe-4">
              <span className="badge fw-normal rounded-pill border border-primary text-primary-blue px-3 py-2 mb-3 fs-16">
                <span className="me-2 text-success fs-16">●</span>Strength You Can Rely On
              </span>
              <h2 className="fw-bold fs-36">Driven by Excellence,<br />Powered by the BHEPL Advantage</h2>
              <p className="text-primary-blue mt-3 fs-16">
                Precision engineering, attention to detail, and a relentless focus on safety
                to deliver world-class rail solutions. Guided by global standards and cutting-edge
                engineering techniques, we ensure technical excellence, operational reliability,
                and lasting value. The BHEPL Advantage stands on a strong foundation of expertise,
                innovation, and real-world results.
              </p>
            </div>
            <div className="col-md-6 text-center">
              <img
                src="/flow1.webp"
                alt="Flow"
                className="img-fluid w-100"
                style={{ objectFit: 'contain' }}
              />
            </div>
          </div>

        </div>




        <div className="container my-5">
          <div className="  rounded-4">
            <div className="row align-items-center justify-content-between p-4 p-md-5">
              <div className="col-md-6 text-center mt-4 mt-md-0 pe-md-5">
                <div className="carousel-container">
                  <div id="imageSlider" className="carousel slide" data-bs-ride="carousel" data-bs-interval="2000">
                    <div className="carousel-inner rounded-4 shadow-sm" style={{ height: '350px', overflow: 'hidden' }}>
                      {['/solutions03.webp', '/solutions04.webp'].map((imgSrc, index) => (
                        <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                          <img
                            src={imgSrc}
                            className="d-block w-100"
                            alt={`Slide ${index + 1}`}
                            style={{
                              height: '350px',
                              width: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        </div>
                      ))}
                    </div>

                    <button className="carousel-control-prev bg-grey-color rounded-circle top-50 translate-middle-y" type="button" data-bs-target="#imageSlider" data-bs-slide="prev" style={{ width: '40px', height: '40px', left: '20px' }}>
                      <i className="bi bi-chevron-left fs-4 text-primary-blue text-center pt-1 pe-1"></i>
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next bg-grey-color rounded-circle top-50 translate-middle-y" type="button" data-bs-target="#imageSlider" data-bs-slide="next" style={{ width: '40px', height: '40px', right: '20px' }}>
                      <i className="bi bi-chevron-right fs-4 text-primary-blue text-center pt-1 ps-1"></i>
                      <span className="visually-hidden">Next</span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="col-md-6 ps-4 mt-md-0 mt-3">
                <span className="badge fw-normal rounded-pill border-primary-blue text-primary-blue px-3 py-2 mb-3 fs-16">
                  <span className="me-2 text-success fs-16">●</span>Tailored to Fit. Built to Last.
                </span>
                <p className="fs-36 fw-bold mb-3">Solving Complex Problems, Simply</p>
                <p className="text-primary-blue">
                  At BHEPL, we specialize in delivering high-performance infrastructure and rail systems tailored
                  to evolving transportation needs. Our approach blends deep technical expertise with a commitment
                  to long-term sustainability, reliability, and innovation. From initial concept to lifecycle support,
                  we ensure every solution is built to scale and engineered to last.
                </p>
                <button
                  onClick={() => window.location.href = "solutions"}
                  className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-5 bg-primary-blue"
                >
                  <span className="mx-3 fs-14">Explore More Solutions</span>
                  <div
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    style={{
                      width: '35px',
                      height: '35px',
                      backgroundColor: '#ffffff',
                    }}
                  >
                    <ArrowRight color="#193E6C" />
                  </div>
                </button>
              </div>

            </div>
          </div>
        </div>




        <div className="container my-5">
          <div className="  p-4 p-md-5 rounded-4">
            <div className="row align-items-center">
              {/* Text Section */}
              <div className="col-md-6">
                <span className="badge fw-normal rounded-pill border-primary-blue text-primary-blue px-3 py-2 mb-3 fs-16">
                  <span className="me-2 text-success fs-16">●</span>Our Approach, Your Success
                </span>
                <p className="fs-36 fw-bold mb-3">Engineering Excellence. Scalable Solutions.</p>
                <p className="text-primary-blue">
                  At BHEPL, we specialize in delivering high-performance infrastructure and rail systems tailored
                  to evolving transportation needs. Our approach blends deep technical expertise with a commitment
                  to long-term sustainability, reliability, and innovation. From initial concept to lifecycle
                  support, we ensure every solution is built to scale and engineered to last.
                </p>
                <button
                  onClick={() => window.location.href = "about"}
                  className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-5 bg-primary-blue"
                >
                  <span className="mx-3 fs-14">Know more about us</span>
                  <div
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    style={{
                      width: '35px',
                      height: '35px',
                      backgroundColor: '#ffffff',
                    }}
                  >
                    <ArrowRight color="#193E6C" />
                  </div>
                </button>
              </div>

              <div className="col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
                <img
                  src="/discuss.webp"
                  alt="Discuss"
                  className="img-fluid rounded-4 shadow-sm w-100"
                  style={{ objectFit: 'cover', height: '390px' }}
                />
              </div>
            </div>
          </div>
        </div>






        <div className="row justify-content-center mx-0">
          <div className="col-12 col-md-10 my-5">
            <div className="row align-items-center bg-white rounded-4 p-3 p-md-2">
              <h3 className="mb-4 fw-semibold fs-24">Explore Case Studies</h3>

              <div className="col-12 col-md-5 mb-4 mb-md-0" style={{ height: "350px" }}>
                <img
                  src="/case-study02.webp"
                  alt="case study"
                  className="img-fluid rounded-4 w-100 h-100"
                  style={{
                    objectFit: 'cover',
                    height: '100%',
                    width: '100%',
                    minHeight: '350px',
                    maxHeight: '350px',
                  }}
                />
              </div>

              <div
                className="col-12 col-md-7 d-flex flex-column justify-content-between ps-md-4"
                style={{
                  minHeight: '200px',
                }}
              >
                <div>
                  <h4 className="fw-bold mb-3 fs-36">
                    Yard Safety Management Solution Deployment at Large Steel Producer
                  </h4>
                </div>
                <div>
                  <p className="text-primary-blue mb-3">
                    Implemented a Robust Yard Safety Management Solution at the Angul plant of a leading
                    steel producer. The system enhances safety through real-time monitoring, automated
                    access control, and incident tracking.
                  </p>
                  <p className="text-primary-blue fw-bold fs-18">
                    — Improving compliance, visibility, and operational efficiency in a high-risk industrial
                    environment.
                  </p>
                </div>
                <div>
                  <button
                    onClick={() => window.location.href = "case-studies/case-study"}
                    className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue"
                  >
                    <span className="mx-3 fs-14">View Case Study</span>
                    <div
                      className="d-flex justify-content-center align-items-center rounded-circle"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: '#ffffff',
                      }}
                    >
                      <ArrowRight color="#193E6C" />
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container my-5">
          <div className="bg-grey-color p-4 p-md-5 rounded-4">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h6 className="fs-20 text-primary-blue fw-bold">Meet Our Team</h6>
                <p className="fs-32 fw-bold mb-1">Let’s Build the Railways of Tomorrow</p>
                <p className="fs-18">
                  Whether you’re modernizing legacy infrastructure or pioneering new corridors,
                  BHEPL is your trusted technology ally. Together, let’s shape the intelligent
                </p>
                <button
                  onClick={() => window.location.href = "contact"}
                  className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white bg-primary-blue"
                >
                  <span className="mx-3 fs-14">Contact us for Strategic Collaboration</span>
                  <div
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    style={{
                      width: '35px',
                      height: '35px',
                      backgroundColor: '#ffffff',
                    }}
                  >
                    <ArrowRight color="#193E6C" />
                  </div>
                </button>
              </div>

              <div className="col-md-6 d-flex align-items-stretch mt-4 mt-md-0">
                <img
                  src="/discuss2.webp"
                  alt="Discuss"
                  className="img-fluid rounded-4 shadow-sm w-100"
                  style={{
                    objectFit: 'cover',
                    width: '100%',
                    height: 'auto',
                    minHeight: '200px',
                  }}
                />
              </div>
            </div>
          </div>
        </div>





        {/* <div className="container my-5">
          <div className="  p-4 p-md-5 rounded-4">
            <h2 className="mb-4 fw-bold">Explore Case Studies</h2>

            <div
              className="d-flex overflow-auto gap-1 pb-3"
              style={{ scrollSnapType: 'x mandatory', WebkitOverflowScrolling: 'touch' }}
            >
              {[...Array(5)].map((_, i) => (
                <div
                  key={i}
                  className="flex-shrink-0 rounded-4 shadow-sm p-3"
                  style={{
                    width: '220px',
                    scrollSnapAlign: 'start',
                    border: '1px solid #eee',
                    backgroundColor: '#FBFAF9',
                  }}
                >
                  <img
                    src="/case1.webp"
                    alt="Case Study"
                    className="img-fluid rounded mb-3 w-100"
                    style={{ height: '160px', objectFit: 'cover' }}
                  />
                  <h6 className="fw-bold">Streamlining IT Solutions: A Guide for Business Leaders</h6>
                  <p className="text-muted small">
                    Streamlining IT Solutions: A Guide for Business Leaders
                  </p>
                  <a href="#" className="text-primary-blue text-decoration-underline fw-medium text-underline-offset-4">
                    Read More <span className="">&#8594;</span>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div> */}


















        {/* <div className="row align-items-start justify-content-center mx-0">
          <div className="col-12 col-md-4 mb-4 mb-md-0 text-start me-2" style={{ backgroundColor: "#F4F4F4" }}>
            <h2 className="fw-normal">BHEPL isn’t just a technology company</h2>
            <p className="mt-5">
              From modernizing legacy networks to developing next-generation control and safety systems, our work is built on trust, performance, and future-readiness. With every project, we aim to raise the bar for what’s possible in rail.
            </p>
          </div>
          <div className="col-12 col-md-4">
            <img
              src="/train.webp"
              alt="train"
              className="img-fluid w-100"
              style={{ maxHeight: "460px", objectFit: "cover" }}
            />
          </div>
        </div>
        <div className="row align-items-start justify-content-center mx-0 mt-4">
          <div className="col-12 col-md-4 me-2">
            <img
              src="/discuss.webp"
              alt="discuss"
              className="img-fluid w-100"
              style={{ maxHeight: "460px", objectFit: "cover" }}
            />
          </div>
          <div className="col-12 col-md-4 mb-4 mb-md-0 text-start" style={{ backgroundColor: "#F4F4F4" }}>
            <h6 className="mt-3 fw-normal">Our specialist consultants understands the importance of maintaining a long lasting relationships with clients to deliver investment solutions for success with a team of experts with in depth knowledge.</h6>
            <p className="mt-3 text-black-50 fs-6">
              We also offer expert guidance, unlocking your potential for growth that helps proof business investment as advisors!</p>
            <button
              onClick={() => window.location.href = "about"}
              className="btn d-flex align-items-center px-1 py-1 rounded-pill text-white mt-3"
              style={{ backgroundColor: "#193E6C" }}
            >
              <span className="mx-3">More about us</span>
              <div
                className="d-flex justify-content-center align-items-center rounded-circle"
                style={{
                  width: '35px',
                  height: '35px',
                  backgroundColor: '#ffffff',
                }}
              >
                <ArrowRight color="#193E6C" />
              </div>
            </button>

          </div>
        </div>



        <div className="row align-items-start justify-content-center mx-0 mt-3">
          <div className="col-12 col-md-4 mb-4 mb-md-0 text-start me-2 p-3 rounded-3 text-white" style={{ backgroundColor: "#193E6C" }}>
            <h6 className="mt-1 fw-normal">Where Rail Engineering Meets Next-Gen Thinking</h6>
            <h3 className="">Harness the power of innovation to build smarter, safer, more resilient rail networks.</h3>
            <p className="mt-5">
              Because for us, progress isn’t optional. It’s engineered.
            </p>
            <button
              onClick={() => window.location.href = "about"}
              className="btn d-flex align-items-center px-1 py-1 rounded-pill bg-white mt-3 mb-2"
            >
              <span className="mx-3" style={{ color: "#193E6C" }}>Learn How We're Reimagining Rail</span>
              <div
                className="d-flex justify-content-center align-items-center rounded-circle"
                style={{
                  width: '35px',
                  height: '35px',
                  backgroundColor: '#193E6C',
                }}
              >
                <ArrowRight color="white" />
              </div>
            </button>
          </div>
          <div className="col-12 col-md-4">
            <img
              src="/gears.webp"
              alt="gears"
              className="img-fluid w-100"
              style={{ maxHeight: "460px", objectFit: "cover" }}
            />
          </div>
        </div>




        <div id="products" className="container text-center mt-5">
          <div className="d-flex">
            <h2>Products</h2>
          </div>
          <div className="row justify-content-center gx-4 gy-3 mt-3">
            {[
              { name: "article1", url: "/#products" },
              { name: "article2", url: "/#products" },
              { name: "article3", url: "/#products" },
            ].map((item, index) => (
              <div key={index} className="col-12 col-sm-4 col-md-4">
                <a href={item.url}>
                  <img
                    src={`/${item.name}.webp`}
                    alt={`${item.name} ${index + 1}`}
                    className="img-fluid h-100"
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
        <div style={{ height: "80px" }}></div>
        <div id="case-studies" className="container mt-5 text-center">
          <div className="d-flex">
            <h2>Case Studies</h2>
          </div>
          <div className="row mt-4 gx-4 gy-3">
            {[
              {
                image: "case1",
                title: "Innovative Marketing Strategies for Small Businesses",
                description: "Learn about innovative marketing strategies tailored for small businesses to stand out, attract customers, and drive growth in competitive markets.",
                url: "/#case-studies"
              },
              {
                image: "case2",
                title: "The Importance of Diversity and Inclusion in Today's Workplace",
                description: "Delve into the significance of fostering diversity and inclusion in the workplace. driving innovation, creativity, and employee engagement for organizational success.",
                url: "/#case-studies"
              },
              {
                image: "case3",
                title: "Mastering Time Management: Tips for Busy Professionals",
                description: "Discover practical time management tips and techniques to enhance productivity, prioritize tasks effectively, and achieve work-life balance for busy professionals",
                url: "/#case-studies"
              }
            ].map((item, index) => (
              <div key={index} className="col-12 col-md-4 text-start">
                <img src={`/${item.image}.webp`} alt={item.image} className="img-fluid mb-3" />
                <div>
                  <p className="fw-bold">{item.title}</p>
                </div>
                <div>
                  <p className="text-muted">{item.description}</p>
                </div>
                <div>
                  <a href={item.url} className="text-decoration-none">
                    Read more
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="container mt-5 text-center">
          <div className="d-flex justify-content-center">
            <h3 className="col-md-5 fs-4">Trusted by forward-thinking organisations all around the world.</h3>
          </div>
          <div className="row mt-4 gx-4 gy-3 justify-content-center">
            {["logo-trust", "logo-trust", "logo-trust", "logo-trust"].map((client, index) => (
              <div key={index} className="col-4 col-md-2">
                <img src={`/${client}.webp`} alt={client} className="img-fluid" />
              </div>
            ))}
          </div>
        </div> */}

        <div style={{ height: "80px" }}></div>
        <Footer />
      </div>
    );
  }
}
